export const isHeicFile = (file = {}) => {
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  return type.includes("heic") || type.includes("heif") || /\.(heic|heif)$/i.test(name);
};

const jpgNameFor = (fileName = "image.heic") => fileName.replace(/\.(heic|heif)$/i, ".jpg");

const toJpegFile = (blob, sourceFile) => new File([blob], jpgNameFor(sourceFile.name), {
  lastModified: sourceFile.lastModified || Date.now(),
  type: "image/jpeg",
});

export const convertHeicToJpeg = async (file) => {
  if (!isHeicFile(file)) return file;
  const result = await convertHeicToJpegResult(file);
  if (!result.converted) {
    throw result.error || new Error("Unable to convert HEIC file.");
  }
  return result.file;
};

export const convertHeicToJpegResult = async (file) => {
  if (!isHeicFile(file)) {
    return { converted: false, error: null, file, originalFile: file };
  }
  const errors = [];
  try {
    const { default: heic2any } = await import("heic2any");
    const converted = await heic2any({
      blob: file,
      quality: 0.92,
      toType: "image/jpeg",
    });
    const blob = Array.isArray(converted) ? converted[0] : converted;
    return { converted: true, error: null, file: toJpegFile(blob, file), originalFile: file };
  } catch (error) {
    errors.push(error);
  }

  try {
    const mod = await import("heic-to");
    const heicTo = mod.heicTo || mod.default?.heicTo || mod.default;
    const blob = await heicTo({
      blob: file,
      quality: 0.92,
      type: "image/jpeg",
    });
    return { converted: true, error: null, file: toJpegFile(blob, file), originalFile: file };
  } catch (error) {
    errors.push(error);
  }

  return {
    converted: false,
    error: new Error(errors.map((error) => error?.message).filter(Boolean).join("; ") || "Unable to convert HEIC file."),
    file,
    originalFile: file,
  };
};

export const conversionWarningFor = (result) => {
  if (!result || result.converted || !isHeicFile(result.originalFile || result.file)) return "";
  return `Could not convert ${result.originalFile?.name || result.file?.name || "HEIC file"} to JPEG. It was attached as the original HEIC file and may not preview in the browser.`;
};

export const legacyConvertHeicToJpeg = async (file) => {
  if (!isHeicFile(file)) return file;
  const { default: heic2any } = await import("heic2any");
  const converted = await heic2any({
    blob: file,
    quality: 0.92,
    toType: "image/jpeg",
  });
  const blob = Array.isArray(converted) ? converted[0] : converted;
  return toJpegFile(blob, file);
};
